var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.appid || _vm.appid.length === 0
        ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
            _c("h4", { staticClass: "alert-heading" }, [
              _vm._v("Facebook App ID is not set"),
            ]),
            _c(
              "div",
              { staticClass: "alert-body" },
              [
                _c("span", [_vm._v("Please set the Facebook App ID in the")]),
                _c(
                  "b-link",
                  {
                    staticClass: "mx-1",
                    attrs: { to: { name: "pages-facebook-setting" } },
                  },
                  [_vm._v("Marketing Settings")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.appid && _vm.appid.length > 0
        ? _c(
            "div",
            { staticClass: "facebook__login card p-3 text-center bg-info" },
            [
              _c("div", { staticClass: "text" }, [
                _c("h3", { staticClass: "text-white" }, [
                  _vm._v("Facebook Login"),
                ]),
                _c("p", { staticClass: "text-white" }, [
                  _vm._v("Login with Facebook to view all your posts"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-content-center",
                    attrs: { id: "app" },
                  },
                  [
                    _c("v-facebook-login", {
                      attrs: { "app-id": _vm.firstAppId },
                      on: {
                        "sdk-init": _vm.handleSdkInit,
                        login: _vm.onLogin,
                        logout: _vm.logout,
                      },
                      model: {
                        value: _vm.model,
                        callback: function ($$v) {
                          _vm.model = $$v
                        },
                        expression: "model",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "content-with-sidebar",
        { staticClass: "blog-wrapper" },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loadingMarketing
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
          !_vm.loadingMarketing
            ? _c(
                "b-row",
                { staticClass: "blog-list-wrapper" },
                _vm._l(_vm.posts, function (blog) {
                  return _c(
                    "b-col",
                    { key: blog.id, attrs: { md: "4" } },
                    [
                      _c(
                        "b-card",
                        { attrs: { tag: "article", "no-body": "" } },
                        [
                          _c("b-img", {
                            staticClass: "card-img-top fluid",
                            attrs: {
                              src: blog.fullPicture
                                ? blog.fullPicture
                                : _vm.facebookImage,
                              height: "300",
                              width: "100",
                            },
                          }),
                          _c(
                            "b-card-body",
                            [
                              _c(
                                "b-card-title",
                                [
                                  _c(
                                    "b-link",
                                    {
                                      staticClass:
                                        "blog-title-truncate text-body-heading",
                                    },
                                    [_vm._v(" " + _vm._s(blog.message) + " ")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-media",
                                { attrs: { "no-body": "" } },
                                [
                                  _c("b-media-aside", {
                                    staticClass: "mr-50",
                                    attrs: { "vertical-align": "center" },
                                  }),
                                  _c("b-media-body", [
                                    _c(
                                      "small",
                                      { staticClass: "text-muted mr-50" },
                                      [_vm._v("by")]
                                    ),
                                    _c(
                                      "small",
                                      [
                                        _c(
                                          "b-link",
                                          { staticClass: "text-body" },
                                          [_vm._v(_vm._s(_vm.userId.name))]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "text-muted ml-75 mr-50" },
                                      [_vm._v("|")]
                                    ),
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(_vm._s(blog.updatedTime)),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c("hr"),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center",
                                },
                                [
                                  _c(
                                    "BRow",
                                    [
                                      _c(
                                        "BCol",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "font-weight-bold",
                                              attrs: {
                                                variant: "primary",
                                                href: blog.permalinkUrl,
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v(" View in Facebook ")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "BCol",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "font-weight-bold w-100",
                                              attrs: {
                                                variant: "danger",
                                                target: "_blank",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deletePost(blog.id)
                                                },
                                              },
                                            },
                                            [_vm._v(" Delete ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "blog-sidebar py-2 py-lg-0",
              attrs: { slot: "sidebar" },
              slot: "sidebar",
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-2 d-flex justify-content-center" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            block: "",
                            to: {
                              path: "/marketing/blog/add",
                              query: { access_token: _vm.facebookToken },
                            },
                          },
                        },
                        [_vm._v(" Add Content ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }